<template>
<div>
  <ckeditor
    :class="errorsMsg[0] && errorsMsg[0].length > 0 ? 'cke_error_message' : ''"
    v-model="contents"
    :editor-url="editorUrl"
    :config="editorConfig"
    @namespaceloaded="onNamespaceLoaded"
    :read-only="disabled"
  ></ckeditor>
  <div class="error--text" v-if="errorsMsg[0] && errorsMsg[0].length > 0">{{ errorsMsg[0]}}</div>
</div>
</template>

<script>

export default {
  name: 'DefaultCKEditor',
  props: {
    value: {
      type: String,
    },
    height: {
      type: Number,
      required: false,
      default: 500,
    },
    errorsMsg: {
      type: [String, Array],
    },
    disabled: {
      type: [Boolean],
    },
  },
  data() {
    return {
      editorUrl: 'https://cdn.ckeditor.com/4.14.0/full-all/ckeditor.js',
      editorConfig: {
        height: this.height,
        extraPlugins: ['image2'],
        removePlugins: ['image'],
      },
    };
  },
  computed: {
    contents: {
      get() {
        return this.value ?? '';
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onNamespaceLoaded(CKEDITOR) {
      const pluginBaseDir = `${window.location.origin }${process.env.VUE_APP_BASE_URL}ckeditor/plugins/`;
      const pluginList = ['youtube', 'base64image', 'emoji'];
      this.editorConfig.extraPlugins = this.editorConfig.extraPlugins.concat(pluginList).sort();

      pluginList.forEach((plugin) => {
        CKEDITOR.plugins.addExternal(plugin, `${pluginBaseDir}${plugin}/`, 'plugin.js');
      });
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .cke_error_message .cke{
  border-color: red;
}
</style>
